"use strict";

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
};

Object.defineProperty(exports, "__esModule", {
  value: !0
});

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

var createComponentTheme = function createComponentTheme(theme, componentStyles) {
  var vstui = theme.vstui,
      other = _objectWithoutProperties(theme, ["vstui"]);

  return _extends({
    vstui: _extends({}, componentStyles, vstui)
  }, other);
};

exports.default = createComponentTheme;